import { createSlice } from '@reduxjs/toolkit';
import { SustainabilityCertificationDto } from '../../models/certification';

const initialState: {
	certificationBodies: SustainabilityCertificationDto[];
} = {
	certificationBodies: []
};

const certificationSlice = createSlice({
	name: 'certification',
	initialState,
	reducers: {
		setCertificationBodies(
			state,
			action: { payload: { certificationBodies: SustainabilityCertificationDto[] } }
		) {
			const { certificationBodies } = action.payload;
			state.certificationBodies = certificationBodies;
		}
	}
});

export const { setCertificationBodies } = certificationSlice.actions;

export const selectCertificationBodies = (state: {
	certification: { certificationBodies: SustainabilityCertificationDto[] };
}): SustainabilityCertificationDto[] | null => state.certification?.certificationBodies ?? null;

export default certificationSlice.reducer;
